<template>
    <v-container>
	    <div>
            <s-crud
                title="Listado de Conteo Etiquetas"
                :config="config"
                :filter="filter"
                ref="gridTagCountList"
                @rowSelected="rowSelected($event)"                     
                :single-row="false"
            >
                <template v-slot:options>
                    <v-tooltip bottom="">
                        <template v-slot:activator="{ on }">
                            <v-btn
                            v-on="on"
                            text
                            black
                            small
                            @click="editSelected()"
                            >
                            <i class="fas fa-pen"></i>
                            </v-btn>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom="">
                        <template v-slot:activator="{ on }">
                            <v-btn
                            v-on="on"
                            text
                            small
                            @click="deleteSelected()"
                            >
                            <i class="mdi mdi-minus-circle-outline" style="padding-top: 2px;"></i>
                            </v-btn>
                        </template>
                        <span>Eliminar</span>
                    </v-tooltip>
                    <v-tooltip bottom="">
                        <template v-slot:activator="{ on }">
                            <v-btn
                            v-on="on"
                            text
                            small
                            @click="Transfer()"
                            >
                            <i class="mdi mdi-swap-horizontal" style="padding-top: 2px;"></i>
                            </v-btn>
                        </template>
                        <span>Transferencia</span>
                    </v-tooltip>

                </template>
                <template v-slot:filter>
                    <v-container>
                        <v-row>
                            <v-col cols="4" lg="4" md="4">
                                <s-select-definition
                                    label="Destino"
                                    :def="1181"
                                    v-model="filter.TypeDestiny"
                                    @change="getTypeArea(filter.TypeDestiny)"							
                                    >
                                </s-select-definition>
                            </v-col>
                            <v-col cols="4" lg="4" md="4">
                                <s-select-definition
                                    :dgr="dgr"
                                    label="Linea Empaque"
                                    :def="1315"
                                    v-model="filter.TypeLine"
                                    
                                    >
                                </s-select-definition>
                            </v-col>
                            <v-col cols="4" lg="4" md="4">
                                <s-select-definition
                                    label="Faja"
                                    :def="1472"
                                    v-model="filter.TypeBelt"
                                    >
                                </s-select-definition>
					        </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" lg="4" md="4">
                                <s-text 
                                    label="Documento" 
                                    number
                                    v-model="filter.CbpNumberDocument"
                                    ref="stext"
                                ></s-text>
					        </v-col>
                            <v-col cols="4" lg="4" md="4">
                                <s-select
                                label="Turno de Produccion"
                                :items="itemTurn"
                                item-value="TrnID"
                                item-text="TnrObservation"
                                v-model="processInitial.TrnID"
                                >  
                                </s-select>
                            </v-col>
                            <v-col cols="4" lg="4" md="4">
                                <s-select-definition
                                    label="Turno"
                                    :def="1278"
                                    v-model="filter.TypeTurn"
                                ></s-select-definition>
                            </v-col>
                            <!-- <v-col cols="2" lg="2" md="2">
                                <v-btn
                                    block
                                    rounded
                                    color="primary"
                                    @click="Transfer()">
                                    Transferencia  
                                    <i class="fas fa-exchange-alt  fa-3x"></i>
                                </v-btn>     
                            </v-col> -->
                        </v-row>
                    </v-container>
                </template>
                         
            </s-crud>
        </div>
            <v-dialog persistent v-model="openModal" v-if="openModal" width="700">
			<v-card>
				<v-col>
					<v-row>
						<s-toolbar
							save
							@save="save({})"
							:color="'#BAB6B5'"
							dark
							label=""
							close
							@close="close()"
						/>
					</v-row>

					<v-row>
                            <v-col cols="4" lg="4" md="4">
                                <s-select-definition
                                    label="Destino"
                                    :def="1181"
                                    v-model="item.TypeDestiny"
                                    @change="getTypeArea(item.TypeDestiny)"									
                                    >
                                </s-select-definition>
                            </v-col>
                            <v-col cols="4" lg="4" md="4">
                                <s-select-definition
                                    :dgr="dgr"
                                    label="Linea Empaque"
                                    :def="1315"
                                    v-model="item.TypeLine"                                   
                                    >
                                </s-select-definition>
                            </v-col>
                            <v-col cols="4" lg="4" md="4">
                                <s-select-definition
                                    label="Faja"
                                    :def="1472"
                                    v-model="item.TypeBelt"
                                    >
                                </s-select-definition>
					        </v-col>
                        </v-row>
				</v-col>
			</v-card>
		    </v-dialog>

            <!-- Modal de Edición Masiva -->
            <v-dialog 
                persistent 
                v-model="openEditModal" 
                v-if="openEditModal" 
                max-width="600"
                transition="dialog-bottom-transition"
            >
                <v-card class="elevation-12" shaped>
                    <!-- Header con gradiente -->
                    <v-card-title class="pa-0">
                        <div class="edit-header">
                            <div class="d-flex align-center justify-space-between w-100 px-6 py-4">
                                <div class="d-flex align-center">
                                    <v-icon large color="white" class="mr-3">
                                        mdi-pencil-box-multiple
                                    </v-icon>
                                    <div>
                                        <h3 class="text-h5 font-weight-bold white--text mb-1">
                                            Edición Múltiple
                                        </h3>
                                        <p class="caption white--text mb-0 opacity-90">
                                            Actualizar registros seleccionados
                                        </p>
                                    </div>
                                </div>
                                <v-btn 
                                    icon 
                                    dark 
                                    @click="openEditModal = false"
                                    class="close-btn"
                                >
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-card-title>

                    <v-card-text class="px-6 py-6">

                        <!-- Formulario -->
                        <v-form ref="editForm">
                            <div class="form-section mb-4">
                                <div class="section-label mb-2">
                                    <v-icon small class="mr-2" color="primary">mdi-ruler</v-icon>
                                    <span class="font-weight-medium text-body-2 text--secondary">
                                        CALIBRE
                                    </span>
                                </div>
                                <s-select-definition
                                    :def="1266"
                                    label="Seleccione el calibre"
                                    v-model="editItem.TypeCaliber"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-arrow-expand-horizontal"
                                >
                                </s-select-definition>
                            </div>

                            <div class="form-section">
                                <div class="section-label mb-2">
                                    <v-icon small class="mr-2" color="primary">mdi-package-variant</v-icon>
                                    <span class="font-weight-medium text-body-2 text--secondary">
                                        PRESENTACIÓN
                                    </span>
                                </div>
                                <s-select
                                    :items="itemsPresentation"
                                    item-value="PrcID"
                                    full
                                    autocomplete
                                    item-text="PresentationName"
                                    label="Seleccione una presentación"
                                    v-model="editItem.PrcID"
                                    clearable
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-package"
                                ></s-select>
                            </div>
                        </v-form>
                    </v-card-text>

                    <!-- Footer con acciones -->
                    <v-divider></v-divider>
                    <v-card-actions class="px-6 py-4">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            large
                            @click="openEditModal = false"
                            class="text-none px-6"
                        >
                            <v-icon left small>mdi-cancel</v-icon>
                            Cancelar
                        </v-btn>
                        <v-btn
                            color="primary"
                            large
                            @click="saveEdit()"
                            class="text-none px-8 elevation-2"
                            :disabled="!isFormValid"
                        >
                            <v-icon left>mdi-content-save</v-icon>
                            Guardar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    </v-container>
</template>

<script>
    import _sPrfCountingBoxesPresentationService from "@/services/FreshProduction/PrfCountingBoxesPresentation"
    import _sTurnService from "@/services/FreshProduction/PrfTurnService"; // SERVICIO DEL TURNO
    import _servicePresentation from "@/services/FreshProduction/PrfPresentationConfigService.js";


    export default {
		components: {
		},
        data() {
			return {
				//client:             null,
				filter: {
					
				},
				config: {
                    title: "Listado de Conteo de Etiquetas",
					model: {
						CbpID: "ID",
                        SecCreate: "datetime"					
						
					},
					service: _sPrfCountingBoxesPresentationService,
					headers: [
						{ text: "ID",                   value: "CbpID",                         width: 50,  },
                        { text: "Código",               value: "CbpCode",                       width: 100, },
						{ text: "DNI",                  value: "CbpNumberDocument",             width: 50,  },
                        { text: "PERSONA",              value: "NtpFullName",                   width: 150, },
						{ text: "Linea",	            value: "TypeLineName",                  width: 50,  },					
                        { text: "Destino",              value: "TypeDestinyName",               width: 100, },                   
                        { text: "Calibre",              value: "TypeCaliberName",               width: 100, },
                        { text: "Faja",                 value: "TypeBeltName",                  width: 100, },
                        { text: "Fecha de Creacion",    value: "SecCreate",                     width: 100, },
					],
				},				
				TypeDestiny:    1,
                TypeLine: 1,
                TypeBelt: 1,
				dgr:          70,
                openModal: false,
                item: {},
                itemsSelected: [],
                itemTurn: []    ,
                processInitial:{} ,

                TypeArea: 2,
                itemsPresentation: [],
                openEditModal: false,
                editItem: {
                    PrcID: null,
                    TypeCaliber: null
                }
			};
		},
        watch: {
			
        },
        computed: {
            isFormValid() {
                return this.editItem.TypeCaliber && this.editItem.PrcID;
            }
        },
        methods: {
			rowSelected(item) {
				this.itemsSelected = item;
				console.log("item", this.itemsSelected);
			},
            save(items) {				
                           
               console.log("turnos1111", this.itemTurn);
               if(this.itemTurn.length === 0) {
                this.$fun.alert("Error, No hay turno activo para este destino", "warning")
				return;
               }

                this.itemsSelected.forEach(element => {
                    element.TypeDestiny = this.item.TypeDestiny,
                    element.TypeLine    = this.item.TypeLine,
                    element.TypeBelt    = this.item.TypeBelt,
                    element.TrnID       = this.itemTurn[0].TrnID,
                    element.TypeArea    = this.TypeArea   
                });

                console.log("items" , this.itemsSelected);
                _sPrfCountingBoxesPresentationService.transferCountingBoxes(this.itemsSelected,this.$fun.getUserID()).then((r) => {
                    if(r.status == 200) {
                        this.$fun.alert("Tranferidos Correctamente", "success");
                        //this.clear();
                        this.$refs.gridTagCountList.refresh();			
                        this.$emit('EndProcess', r.status);							
                    } 
                    else { 
                        this.$fun.alert("Ocurrio un error al Transferir", "error");
                        this.$emit('EndProcess', null);
                    }	
                                
                })
			},
            Transfer(){
                console.log("Items",this.itemsSelected);
                if(this.itemsSelected.length == 0){
					this.$fun.alert("Error, no se han seleccionado registros", "warning")
					return;
				}
                this.openModal          = true;
                this.item.TypeDestiny   = this.itemsSelected[0].TypeDestiny;
                this.item.TypeLine      = this.itemsSelected[0].TypeLine;
                this.item.TypeBelt      = this.itemsSelected[0].TypeBelt;
                
            },
            
            close() {
				this.openModal = false;	
			},

            TurnActive(){
            let TypeArea = 2
            console.log("TypeArea: ", this.TypeArea);
            _sTurnService.turnActivePrf({TypeArea : this.TypeArea, TypeShip: 1}, this.$fun.getUserID()).then(r =>{
                    if(r.status == 200)
                    {
                        console.log("Turnos",r.data);
                        this.itemTurn = r.data;
                        if(this.itemTurn.length > 0)
                        this.processInitial.TrnID= this.itemTurn[0].TrnID;                               
                    }
                });      
            },
            getTypeArea(event){
                console.log("destino22",event);
                switch(event){
                    case 1:
                        this.TypeArea = 2;
                        break;
                    case 2:
                        this.TypeArea = 3;
                        break;
                    case 9:
                        this.TypeArea = 10;
                        break;
                }                                
                console.log("TypeArea",this.TypeArea);
                this.itemTurn = [];                 
                this.TurnActive();
            },

            
            // Nuevos métodos para la edición masiva
            loadPresentations() {
				_servicePresentation
					.listPresentation("" ,this.$fun.getUserID())
					.then(r => {
						this.itemsPresentation = r.data;
					});
            },

            editSelected() {
                if(this.itemsSelected.length == 0){
					this.$fun.alert("Error, no se han seleccionado registros para editar", "warning")
					return;
				}
                this.editItem.PrcID = null;
                this.editItem.TypeCaliber = null;
                this.openEditModal = true;
                // Cargar presentaciones si aún no se han cargado
                if(this.itemsPresentation.length === 0) {
                    this.loadPresentations();
                }
            },

            async saveEdit() {
                if (!this.editItem.PrcID || !this.editItem.TypeCaliber) {
                    this.$fun.alert("Seleccione Presentación y Calibre", "warning");
                    return;
                }

                const confirm = await this.$fun.alert("¿Está seguro de actualizar estos registros?", "question");
                if (!confirm.isConfirmed) return;

                let errors = 0;
                let success = 0;

                for (const item of this.itemsSelected) {
                    let itemToUpdate = { ...item };
                    itemToUpdate.PrcID = this.editItem.PrcID;
                    itemToUpdate.TypeCaliber = this.editItem.TypeCaliber;
                    itemToUpdate.UsrCreateID = this.$fun.getUserID(); 
                    itemToUpdate.UsrUpdateID = this.$fun.getUserID();

                    try {
                        const resp = await _sPrfCountingBoxesPresentationService.save(
                            itemToUpdate,
                            this.$fun.getUserID()
                        );
                        if (resp.status == 200) {
                            success++;
                        } else {
                            errors++;
                        }
                    } catch (error) {
                        console.error("Error al actualizar item:", item.CbpID, error);
                        errors++;
                    }
                }

                if (errors === 0) {
                    this.$fun.alert(`Se actualizaron ${success} registros correctamente`, "success");
                    this.openEditModal = false;
                    this.$refs.gridTagCountList.refresh();
                    this.itemsSelected = []; // Limpiar selección
                } else {
                    this.$fun.alert(`Se completó con ${errors} errores. Actualizados: ${success}`, "warning");
                    this.$refs.gridTagCountList.refresh();
                }
            },

            async deleteSelected() {
                if (this.itemsSelected.length == 0) {
                    this.$fun.alert("Error, no se han seleccionado registros para eliminar", "warning");
                    return;
                }

                const confirm = await this.$fun.alert(`¿Está seguro de eliminar ${this.itemsSelected.length} registros seleccionados?`, "question");
                if (!confirm.isConfirmed) return;

                let errors = 0;
                let success = 0;

                for (const item of this.itemsSelected) {
                    let itemToUpdate = { ...item };
                    itemToUpdate.SecStatus = 0; 
                    itemToUpdate.UsrUpdateID = this.$fun.getUserID();

                    try {
                        const resp = await _sPrfCountingBoxesPresentationService.save(
                            itemToUpdate,
                            this.$fun.getUserID()
                        );
                        if (resp.status == 200) {
                            success++;
                        } else {
                            errors++;
                        }
                    } catch (error) {
                        console.error("Error al eliminar item:", item.CbpID, error);
                        errors++;
                    }
                }

                if (errors === 0) {
                    this.$fun.alert(`Se eliminaron ${success} registros correctamente`, "success");
                    this.$refs.gridTagCountList.refresh();
                    this.itemsSelected = [];
                } else {
                    this.$fun.alert(`Se completó con ${errors} errores. Eliminados: ${success}`, "warning");
                    this.$refs.gridTagCountList.refresh();
                }
            },
        },
        created () {
            this.TurnActive();            
	    },	
	};
</script>
<style scoped>
.edit-header {
    background: linear-gradient(135deg, #667eea 0%, #667eea 100%);
    width: 100%;
    border-radius: 4px 4px 0 0;
}

.opacity-90 {
    opacity: 0.9;
}

.close-btn {
    transition: transform 0.2s;
}

.close-btn:hover {
    transform: rotate(90deg);
}

.form-section {
    position: relative;
}

.section-label {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.v-card {
    border-radius: 12px !important;
    overflow: hidden;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>